var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout"},[_c('v-app',{staticStyle:{"background-color":"rgb(252,252,255)"}},[_c('v-main',[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }